import type { IApiProductSettings } from '@/types'
import {
  type IAccountSettings,
  type ISearchRequest,
  type ISearchResults,
} from '@/types'
import axios from 'axios'
import { config } from './config/generated-config'

const getJamsApi = () => {
  return config.VITE_JAMS_BACKEND_URL
}

export const getAccountSettings = async (
  accountId: string,
): Promise<IAccountSettings | null> => {
  const endpoint = getJamsApi()
  const path = `account?accountName=${accountId}`

  // Remove verbose request logging - not actionable
  // console.info('micro_srp', 'get account info', {
  //   request: `${endpoint}/${path}`,
  // })

  const response = await fetch(`${endpoint}/${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  try {
    const responseJson: any = await response.json()

    if (!response.ok) {
      return null
    }

    return responseJson
  } catch (error) {
    console.error('micro_srp', 'get account info', error)
    return null
  }
}

export const getProductSettings = async (
  accountId: string,
  productId: string,
): Promise<IApiProductSettings | null> => {
  const endpoint = getJamsApi()
  const path = `unauth/account/products/${accountId}/${productId}`

  const response = await fetch(`${endpoint}/${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  try {
    const responseJson: any = await response.json()

    if (!response.ok) {
      throw new Error('API Error')
    }

    return responseJson
  } catch (error) {
    console.error(error)
    return null
  }
}

export const doSearch = async (
  searchEndpoint: string,
  searchParams: ISearchRequest,
): Promise<ISearchResults> => {
  try {
    const cancelTokenSource = axios.CancelToken.source()
    const timeoutId = setTimeout(
      () => cancelTokenSource.cancel('Request timed out'),
      30000,
    )

    const response = await axios.get(`${searchEndpoint}/items-passthrough`, {
      params: searchParams, // Axios will automatically convert this to query parameters
      cancelToken: cancelTokenSource.token,
    })

    clearTimeout(timeoutId)

    return response.data
  } catch (err) {
    console.error('Jazel Vuetify', 'doSearch', err)
  }

  return {
    count: 0,
    filters: [],
    items: [],
    searchKeyword: searchParams?.searchKeyword ?? '',
  }
}
